import { useEffect } from 'react'

/**
 * Hook to lock body scroll when a modal/drawer is open.
 * Extracted from 2 duplicated patterns (DUP-4):
 * CheatSheetDrawer, SlideOver.
 *
 * @param isLocked - When true, sets body overflow to hidden
 */
export function useBodyScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (isLocked) {
      const prev = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      return () => {
        document.body.style.overflow = prev
      }
    }
  }, [isLocked])
}
